import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_pencil",
  "use": "icon_pencil-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon_pencil\"><path d=\"M3.544 20.758l.003.003a.947.947 0 00.98.229l5.408-1.835 10.38-10.38a3.384 3.384 0 00-4.786-4.784L5.15 14.37l-1.834 5.409a.946.946 0 00.228.979zM16.391 4.853a2.164 2.164 0 013.061 3.061L18.087 9.28l-3.06-3.061 1.364-1.365zM6.213 15.03l7.951-7.951 3.062 3.06-7.951 7.952-4.633 1.571 1.571-4.632z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol